import type { ReactNode } from "react";
import { Link } from "react-router";

import { Logo } from "../../components/icons";
import { nl } from "../../i18n/nl";
import styles from "./auth.module.css";

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className={styles.page}>
      <main id="inhoud" className={styles.panel}>
        <Link to="/over" className={styles.brand}>
          <Logo size={32} />
          <span>{nl.app.name}</span>
        </Link>
        {children}
      </main>
      <footer className={styles.footer}>{nl.auth.footer}</footer>
    </div>
  );
}

// Shared form fields (also used outside the auth screens).
export { Field, FormError } from "../../components/Field";
export type { FieldProps } from "../../components/Field";
